import {FC, useCallback, useState} from "react";
import ModalPortal from "components-new/ModalPortal";
import Button, { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { useEffect } from "pages/OrganizationPage";
import { useAppDispatch } from "toolkit/hooks";
import { getCodes } from "toolkit/codes/codes.thunks";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import { clearCodes } from "toolkit/codes/codes.slice";
import styles from "./ImportFile.module.sass";
import { FETCH_TIME_IN_MILLISECOND } from "constant/index";
import {directoryAPI} from "../../../../libs/apiClient/Directory";

interface ImportFileProps {
	file: File | null;
	close: () => void;
	clearCurrentOrganization: () => void;
}

const ImportFile: FC<ImportFileProps> = ({ file, close, clearCurrentOrganization }) => {
	const dispatch = useAppDispatch();

	const [loading, setLoading] = useState<boolean>(false);

	const [importAnswer, setImportAnswer] = useState<string>("");

	const continueImport = useCallback(() => {
		file && directoryAPI.okvedImportCreate({file}).then((data) => {
			setImportAnswer(data.data);
			dispatch(clearCodes());
			clearCurrentOrganization();
		});
		//eslint-disable-next-line
	},[file]);

	useEffect(() => {
		const getStatusFile = () => {
			setLoading(true);

			setTimeout(() => {
				directoryAPI.okvedImportResultList({key:importAnswer}).then((data) => {
					if (!data.data) {
						getStatusFile();
					} else {
						dispatch(getCodes({ search: "" }));
						setLoading(false);
						close();
					}
				});
			}, FETCH_TIME_IN_MILLISECOND);
		};

		if (importAnswer) getStatusFile();

		return () => setImportAnswer("");
		//eslint-disable-next-line
	}, [importAnswer]);

	return (
		<ModalPortal
			title={loading ? "Загрузка на сервер" : "Файл загружен"}
			handleClose={() => {
				if (!loading) close();
			}}
			outSide={false}
			className={styles.modal}>
			{!loading ? (
				<div className={styles.text}>
					Загружен файл: <span className={styles.fileName}>{file?.name}</span>
				</div>
			) : (
				<div className={styles.loaderBox}>
					<div className={styles.boxIcon}>
						<LoadingIcon className={styles.loaderIcon} />
					</div>
				</div>
			)}
			{!loading && (
				<div className="df">
					<Button className={styles.button} full variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
						Отменить
					</Button>
					<Button className={styles.button} full onClick={continueImport}>
						Продолжить
					</Button>
				</div>
			)}
		</ModalPortal>
	);
};

export default ImportFile;
